<script lang="ts" setup>
import { useField } from "vee-validate";
import { useSlots } from "vue";
import BaseInput from "./_base.vue";

interface Props {
    value?: boolean;
    name: string;
    label?: string;
}

const props = withDefaults(defineProps<Props>(), {
    value: undefined,
    name: undefined,
    label: undefined,
});

const slots = useSlots();
const hasSlot = (name: string) => !!slots[name];

const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
} = useField(props.name, undefined, {
    initialValue: props.value,
});

function customHandleChange(e: Event) {
    handleChange(e);
}
</script>

<template>
    <BaseInput :errorMessage="errorMessage" :meta="meta" :name="name">
        <div class="form-check flex flex-row gap-2">
            <div class="relative h-5 w-5 flex-shrink-0">
                <input
                    :id="`check_${name}`"
                    class="form-check-input float-left mr-2 h-full w-full cursor-pointer appearance-none rounded-[.25rem] border border-gray-500 bg-white bg-contain bg-center bg-no-repeat align-top transition duration-200 checked:border-orange hover:checked:text-orange focus:!text-orange focus:outline-none focus:!ring-orange"
                    type="checkbox"
                    v-model="inputValue"
                    :name="name"
                />
                <transition name="fade">
                    <span v-if="inputValue" class="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <svg width="16" height="16" viewBox="0 0 24 24" stroke-width="2" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m10 15.586l-3.293-3.293l-1.414 1.414L10 18.414l9.707-9.707l-1.414-1.414z" /></svg>
                    </span>
                </transition>
            </div>
            <label class="form-check-label inline-block cursor-pointer select-none" :for="`check_${name}`">
                <slot v-if="hasSlot('default')"></slot>
                <template v-else>{{ label }}</template>
            </label>
        </div>
    </BaseInput>
</template>

<style lang="scss" scoped>
.md .form-check {
    align-items: center;
}
.md input {
    margin-top: 0;
    width: 30px;
    height: 30px;
    background-color: #09132110;
    border-color: #09132110;
}

.form-check-label {
    :deep(a) {
        @apply text-orange underline hover:no-underline;
    }
}
</style>
